var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { connectStore, adoptedStyle, customElement, property } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { locale } from '../lib/locale';
import './use';
const style = createCSSSheet(css `
  :host {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
  }
  .icon {
    width: 3em;
  }
`);
/**
 * @customElement dy-empty
 */
let DuoyunEmptyElement = class DuoyunEmptyElement extends GemElement {
    constructor() {
        super(...arguments);
        this.render = () => {
            return html `
      ${this.icon ? html `<dy-use class="icon" .element=${this.icon}></dy-use>` : ''}
      <div>${this.description || locale.noData}</div>
    `;
        };
    }
};
__decorate([
    property
], DuoyunEmptyElement.prototype, "icon", void 0);
__decorate([
    property
], DuoyunEmptyElement.prototype, "description", void 0);
DuoyunEmptyElement = __decorate([
    customElement('dy-empty'),
    adoptedStyle(style),
    connectStore(locale)
], DuoyunEmptyElement);
export { DuoyunEmptyElement };
//# sourceMappingURL=empty.js.map